import React from "react";
import { WifiOff, Wifi } from "lucide-react";
import { usePWA } from "./PWAInstaller";

export function OfflineIndicator() {
  const { isOnline, updateAvailable, updateApp } = usePWA();

  if (isOnline && !updateAvailable) {
    return null;
  }

  return (
    <div className="fixed top-4 left-4 right-4 z-50 md:left-1/2 md:right-auto md:-translate-x-1/2 md:max-w-sm">
      {!isOnline && (
        <div className="bg-orange-500/90 backdrop-blur-sm text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 text-sm">
          <WifiOff className="h-4 w-4 flex-shrink-0" />
          <span className="flex-1">
            You're offline. Some features may be limited.
          </span>
        </div>
      )}

      {updateAvailable && (
        <div className="bg-blue-500/90 backdrop-blur-sm text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 text-sm mt-2">
          <Wifi className="h-4 w-4 flex-shrink-0" />
          <span className="flex-1">New version available!</span>
          <button
            onClick={updateApp}
            className="bg-white/20 hover:bg-white/30 px-2 py-1 rounded text-xs font-medium transition-colors"
          >
            Update
          </button>
        </div>
      )}
    </div>
  );
}
